import EffectAmount from '@/roc/effects/EffectAmount';

class CultureAmount extends EffectAmount
{
}

export default CultureAmount;
